// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tinkatink: PokeData = {
  "id": 957,
  "name": "tinkatink",
  "height": 4,
  "weight": 89,
  "base_experience": 59,
  "types": [
    PokeType.FAIRY,
    PokeType.STEEL
  ],
  "api_moves": [
    "slam",
    "sweet-kiss",
    "metal-claw",
    "rock-smash",
    "fake-out",
    "flatter",
    "knock-off",
    "astonish",
    "covet",
    "flash-cannon",
    "draining-kiss",
    "play-rough",
    "fairy-wind",
    "baby-doll-eyes",
    "brutal-swing",
    "skitter-smack"
  ],
  "moves": [
    "sweet-kiss",
    "metal-claw",
    "rock-smash",
    "flatter",
    "play-rough",
    "mist-terrain",
    "iron-defense",
    "behemoth-bash",
    "starfall",
    "smart-strike",
    "heal-bell",
    "spirit-break",
    "hyper-voice"
  ],
  "evolution_chain": {
    "id": 501,
    "item": null,
    "species": [
      {
        "name": "tinkatink",
        "order": 1000,
        "types": [
          PokeType.FAIRY,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "tinkatuff",
        "order": 1001,
        "types": [
          PokeType.FAIRY,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 957,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "tinkaton",
        "order": 1002,
        "types": [
          PokeType.FAIRY,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 958,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 52.25,
    "speed": 58,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
